"use strict";

PF.Field = class Field extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {
				element: undefined,
			},
			model: new PF.Model(),
			key: '',
			required: false,
			error: "",
			errors: {
				required: 'Поле обязательно для заполнения',
			},
			customValidate: undefined,
		};
		}

	init()
		{
		super.init();
		this.valid = true;
		}

	validate(silent, error = undefined)
		{
		if (this.customValidate !== undefined)
			{
			error = this.customValidate.bind(this)(this) || error;
			}
		this.valid = error === undefined;
		this.manageError(silent, error);
		return this.valid;
		}

	manageError(silent, error)
		{
		if (this.valid === true)
			{
			this.error = '';
			}
		else
			{
			if (silent === false)
				{
				this.error = this.applyContext(error);
				}
			}
		}
	};
